import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from './defaultProps'

export const ReplayIcon = createIcon({
  displayName: 'ReplayIcon',
  d: 'M11.929 5.292v-2.79c0-.45-.54-.67-.85-.35l-3.8 3.79c-.2.2-.2.51 0 .71l3.79 3.79c.32.31.86.09.86-.36v-2.79c3.73 0 6.68 3.42 5.86 7.29-.47 2.27-2.31 4.1-4.57 4.57-3.57.75-6.75-1.7-7.23-5.01a1 1 0 0 0-.98-.85c-.6 0-1.08.53-1 1.13.62 4.39 4.8 7.64 9.53 6.72 3.12-.61 5.63-3.12 6.24-6.24.99-5.13-2.91-9.61-7.85-9.61Z',
  defaultProps: defaultProps
})
